import { Text, Separator, Flex } from "@shared/primitive-components"
import { ResolvedFleetEntry } from "../../../api/fleet"
import { ChangedEntriesTable } from "./tables/ChangedEntriesTable"
import { UnchangedEntriesTable } from "./tables/UnchangedEntriesTable"
import * as styles from "./styles"

type Props = {
  changedEntries: ReadonlyArray<ResolvedFleetEntry>
  unchangedEntries: ReadonlyArray<ResolvedFleetEntry>
  displayAddedInErrorWarning?: boolean
}

export const ConfirmFleetEntryChangesContent = ({
  changedEntries,
  unchangedEntries,
  displayAddedInErrorWarning,
}: Props) => (
  <Flex width="100%" flexDirection="column">
    {!!changedEntries.length && (
      <>
        <Text>Please confirm the below updates to your {changedEntries.length !== 1 ? `vehicles` : `vehicle`}</Text>
        <Separator color="gray" size="hairlineFull" />
        <ChangedEntriesTable changedEntries={changedEntries} />
      </>
    )}
    {!!unchangedEntries.length && (
      <>
        <Text css={styles.error}>
          The following vehicles were already on cover during the period that you selected, so we haven&apos;t added
          them. If you wish to edit the on/off cover dates of these vehicles, please select them in the portal and click
          &quot;Edit Cover Dates&quot;
        </Text>
        <Separator color="gray" size="hairlineFull" />
        <UnchangedEntriesTable unchangedEntries={unchangedEntries} />
      </>
    )}
    {!changedEntries.length && !unchangedEntries.length && <Text>There are no changes to your vehicles</Text>}
    {displayAddedInErrorWarning && (
      <Text css={styles.advisory}>
        Once you complete this removal you will need to email{` `}
        <a href="mailto:enquiries@motordatasolutions.co.uk">enquiries@motordatasolutions.co.uk</a>, letting them know
        and provide them with the policyholder name, number, registration and dates.
      </Text>
    )}
    <Text tag="p" css={styles.advisory}>
      By pressing &lsquo;Apply Changes&lsquo; you confirm on behalf of the policyholder that the policyholder is wholly
      responsible for ensuring that all vehicles added to the MID are permitted by the policyholder’s insurer under the
      terms and conditions of its insurance policy. Please note that by adding a vehicle registration number (VRN) to
      your Flock account, you authorise Flock to collect and process telematics data for the specified vehicle from the
      Telematics Service Provider (TSP) you have chosen. If we can match the VRN with the dataset provided by your TSP,
      we will begin collecting and processing data for that vehicle, so you can access the telematics based insights via
      the Flock portal.
    </Text>
  </Flex>
)

ConfirmFleetEntryChangesContent.defaultProps = {
  displayAddedInErrorWarning: false,
}
